import styled from "@emotion/native";

export const Container = styled.View(
	{
		flex: 1,
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.background,
		};
	}
);
